require('dotenv').config()

const apilocal = {
    baseURL: process.env.VUE_APP_URL_DEFAULT
};
export default apilocal;